export const useTestEnvironmentPath = () => {
  const hostName = window.location.host

  return (
    hostName.includes('dev') ||
    hostName.includes('stage') ||
    hostName.includes('localhost')
  )
}
